import type {ListRepresentativesSearchInput} from "./list-representatives.schema";

import {listRepresentatives} from "@project/sdk/sales";
import {ListRepresentativesResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {representativeKeys} from "../../../representative-keys";

import {listRepresentativesSearchSchema} from "./list-representatives.schema";

export function listRepresentativesQueryOptions(rawInput: ListRepresentativesSearchInput) {
  const params = listRepresentativesSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: representativeKeys.list(params),
    queryFn: async ({signal}) =>
      ListRepresentativesResponse.parse(await listRepresentatives(params, {signal})),
  });
}
